import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const SectionBody = styled.div`
  padding: 8px 12px 0;
  margin-bottom: 100px;
`;

export const ConsentLine = styled.div<{ justifyContnt?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justifyContnt || 'space-between'};
  user-select: none;

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }

  &:last-of-type {
    margin-bottom: 60px;
  }
`;

export const ConsentLabel = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ConsentFoldContent = styled.div`
  background-color: ${colors.gray100};
  padding: 16px 20px;
  border-radius: 6px;
  margin-top: 18px;
`;

export const AccordionConsentLine = styled(ConsentLine)`
  cursor: pointer;
`;
